import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Layout from './Layout'

// ReactDOM.createRoot(document.getElementById('root')).render(<App />)
ReactDOM.createRoot(document.getElementById('root')).render(<Layout />)